import {
    TextEncoder
} from 'text-encoding';
import projectData from './project-data';

/* eslint-disable import/no-unresolved */
import popWav from '!arraybuffer-loader!./83a9787d4cb6f3b7632b4ddfebf74367.wav';
import meowWav from '!arraybuffer-loader!./83c36d806dc92327b9e7049a565c6bff.wav';
import backdrop from '!raw-loader!./cd21514d0531fdffb22204e0ec5ed84a.svg';
import costume1 from '!raw-loader!./09dc888b0b7df19f70d81588ae73420e.svg';
import costume2 from '!raw-loader!./3696356a03a8d938318876a593572843.svg';
import E6 from '!raw-loader!./3696356a03a8d93831bb76a593515243.svg';
import C1 from '!raw-loader!./3696356a03a8d93831ab76a593515244.svg';
import E3 from '!raw-loader!./E3-1508.svg';
import M6 from '!raw-loader!./M6.svg';
import C6 from '!raw-loader!./C6.svg';
import A2 from '!raw-loader!./3696356a03a8d93831ab76a593515243.svg';
import E7 from '!raw-loader!./E7-HRCU.svg';
import STORM_OS from '!raw-loader!./STORM_OS.svg';
import M5 from '!raw-loader!./M5.svg';

// 加载png写法，png类型 assetType：ImageBitmap
// import A3 from '!arraybuffer-loader!./3696356a03a8d93831ab76a593515243.png';
// const ay = new Uint8Array(A3)

/* eslint-enable import/no-unresolved */

const encoder = new TextEncoder();

const defaultProject = translator => {
    const projectJson = projectData(translator);
    return [{
        id: 0,
        assetType: 'Project',
        dataFormat: 'JSON',
        data: JSON.stringify(projectJson)
    }, {
        id: '83a9787d4cb6f3b7632b4ddfebf74367',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(popWav)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bff',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(meowWav)
    }, {
        id: 'cd21514d0531fdffb22204e0ec5ed84a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(backdrop)
    }, {
        id: '09dc888b0b7df19f70d81588ae73420e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(costume1)
    }, {
        id: '3696356a03a8d938318876a593572843',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(costume2)
    }, {
        id: '3696356a03a8d93831bb76a593515243',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(E6)
    }, {
        id: '3696356a03a8d93831ab76a593515244',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(C1)
    }, {
        id: '3696356a03a8d93831ab76a593515246',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(E3)
    }, {
        id: '9696356a03a8d93831ab76a593515247',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(M6)
    }, {
        id: '3696356a03a8d93831ab76a593515243',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(A2)
    }, {
        id: '3696356a03a8d93831ab76a593515245',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(E7)
    }, {
        id: '3696356a03a8d93831ab76a593515255',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(STORM_OS)
    }, {
        id: '3696356a03a8d93831ab76a593515256',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(M5)
    }, {
        id: '3696356a03a8d93831ab76a593515257',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(C6)
    }];
};

export default defaultProject;
